export default "__VITE_ASSET__DuBQoVch__"